import React from "react";
import { DataGrid } from "@mui/x-data-grid";
import "./tableCardView.scss";

const TableCardView = (props) => {
  return (
    <>
      <div className="overTableCard">
        <DataGrid
          // getRowId={(r) => r.id}
          getRowId={(r) =>
            r.instructorUserId ??
            r.id + "|" + Date.now() + Math.floor(Math.random() * 100)
          }
          rowHeight={"fit-content"}
          rows={props?.rows}
          columns={props.columns}
          className="tableCard"
          getRowClassName={() => `customRowCard`}
          components={props?.components}
          loading={props?.loading}
          rowCount={props?.rowCount}
          rowsPerPageOptions={props?.rowsPerPageOptions}
          paginationMode="server"
          pageSize={props?.pageSize}
          page={props?.page}
          onPageChange={props?.onPageChange}
          disableSelectionOnClick={true}
          componentsProps={{
            noRowsOverlay: {
              style: { top: 0, position: "relative" },
            },
          }}
          pagination // ✅ ADD THIS
          page={props?.page}
        />
      </div>
    </>
  );
};

export default TableCardView;
